import React, { VFC } from 'react';

import { useRewardTierApplied } from '@fhs/loyalty/src/hooks/use-reward-tier-applied';
import { selectors, useAppSelector } from 'state/global-state';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import { LoyaltyRewardsBalanceView } from './loyalty-rewards-balance.view';

/**
 *
 * <LoyaltyRewardsBalance /> displays at the top of the checkout page
 * and reflects current rewards balance - applied balance in cart
 *
 */
const LoyaltyRewardsBalance: VFC = () => {
  const enableRewardsTiers = useFlag(LaunchDarklyFlag.ENABLE_REWARDS_TIERS);
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser } = useLoyaltyUser();

  const hasContent = loyaltyEnabled && loyaltyUser;

  const _availablePoints = useAppSelector(selectors.loyalty.selectStagedCartPoints);
  const _appliedPoints = useAppSelector(selectors.loyalty.selectAppliedPoints);

  const { rewardTierApplied } = useRewardTierApplied();

  const appliedPoints = enableRewardsTiers ? rewardTierApplied?.points ?? 0 : _appliedPoints;
  const availablePoints =
    enableRewardsTiers && rewardTierApplied?.points
      ? _availablePoints - rewardTierApplied.points
      : _availablePoints;

  if (!hasContent) {
    return null;
  }

  return (
    <LoyaltyRewardsBalanceView availablePoints={availablePoints} appliedPoints={appliedPoints} />
  );
};

export default LoyaltyRewardsBalance;
